/* NAI Signs — product page helpers.
 * Keeps the price shown inside the Add to cart button in sync when the variant changes.
 * Uses Dawn's pub/sub variantChange event (the new section HTML is already fetched by product-info.js). */
(() => {
  if (window.naiProductInit) return;
  window.naiProductInit = true;

  const start = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (!data || !data.html) return;
      const section = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
      if (!section) return;
      const target = section.querySelector('[data-nai-atc-price]');
      const source = data.html.querySelector(`#ProductSubmitButton-${data.sectionId} [data-nai-atc-price]`);
      if (target && source) target.innerHTML = source.innerHTML;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
